import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';


import { ContactComponent }     from './contact.component';
import { AboutComponent }     from './about.component';
import { GardensComponent }     from './gardens.component';
import { GardensDetailComponent }     from './gardens-detail.component';
import { ConstructionComponent }     from './construction.component';
import { ConstructionDetailComponent }     from './construction-detail.component';
import { PoolsComponent }     from './pools.component';
import { PoolsDetailComponent }      from './pools-detail.component';
import { LawnComponent }     from './lawn.component';
import { LawnDetailComponent }     from './lawn-detail.component';
import { BallparkComponent }     from './ballpark.component';
import { ConsultComponent }     from './consult.component';
import { ConsultDetailComponent }     from './consult-detail.component';
import { TrellageComponent }     from './trellage.component'; 
import { TrellageDetailComponent }     from './trellage-detail.component';
import { WallsComponent }     from './walls.component'; 
import { WallsDetailComponent }      from './walls-detail.component'; 
import { FlowerbedsComponent }     from './flowerbeds.component'; 
import { RoofGardenComponent }     from './roofs.component'; 
import { ExtraIrrigationComponent }     from './extrairrigation.component'; 
import { IntraIrrigationComponent }     from './intrairrigation.component'; 
import { IrrigationControlComponent }     from './irrigationcontrol.component'; 
import { IrrigationControlDetailComponent }     from './irrigationcontrol-detail.component'; 
import { PricelistComponent }     from './pricelist.component'; 
import { PricelistDetailComponent }     from './pricelist-detail.component'; 
const routes: Routes = [
  { path: '',  redirectTo: '/onas',pathMatch: 'full'},
  { path: 'kontakt',  component: ContactComponent },
  { path: 'cenik',     component: PricelistComponent },
  { path: 'cenik/detail',     component: PricelistDetailComponent },
  { path: 'onas',    component: AboutComponent  },
  { path: 'poradna',    component: ConsultComponent  },
  { path: 'poradna/dotaz',   component: ConsultDetailComponent },  
  { path: 'zahrady',    component: GardensComponent  },
  { path: 'zahrady/detail',   component: GardensDetailComponent  }, 
  { path: 'stavby',   component: ConstructionComponent  },
  { path: 'stavby/detail',   component: ConstructionDetailComponent  },
  { path: 'jezirka',  component: PoolsComponent },
  { path: 'jezirka/detail',  component: PoolsDetailComponent },
  { path: 'travniky',  component: LawnComponent }, 
  { path: 'travniky/detail',   component: LawnDetailComponent },  
  { path: 'detske-kouty',    component: BallparkComponent  },     
  { path: 'trelaze',    component: TrellageComponent } ,  
  { path: 'trelaze/detail',    component: TrellageDetailComponent } ,
  { path: 'steny',    component: WallsComponent } ,
  { path: 'steny/detail',    component: WallsDetailComponent } ,
  { path: 'kvetinove-kouty',    component: FlowerbedsComponent } ,  
  { path: 'strechy',    component: RoofGardenComponent },
  { path: 'zavlahy-exterier',    component: ExtraIrrigationComponent } ,
  { path: 'zavlahy-interier',    component: IntraIrrigationComponent },
  { path: 'ridici-system',    component: IrrigationControlComponent },       
  { path: 'ridici-system/detail',    component: IrrigationControlDetailComponent },  
];

@NgModule({
  imports: [ RouterModule.forRoot(routes,  { useHash: true }) ],
  //imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/
